import { DYNAMIC_PANEL_TAB_INDEX_MAP} from "../../reducers/dynamicViewSlice"
import {createContext, useContext, useRef} from "react"

const TabPanelScrollContext = createContext(null)

export function useTabPanelScrollEl() {
	return useContext(TabPanelScrollContext)
}

export function TabPanel(props) {
	const { children, value, index, ...other } = props
	const isActive = value === index
	const scrollRef = useRef(null)

	return (
		<TabPanelScrollContext.Provider value={scrollRef}>
			<div
				ref={scrollRef}
				role="tab-panel"
				style={{ minWidth: "100%", height: "calc(100% - 80px)", minHeight: 0, overflowY: "auto", }}
				hidden={!isActive}
				id={`dynamic-tab-panel-${index}`}
				aria-labelledby={`simple-tab-${index}`}
				{...other}
			>
				{children}
			</div>
		</TabPanelScrollContext.Provider>
	)
}

export function NavPanel(props) {
	const { children, value, index } = props

	const isAutomatedSearchPanel = index == DYNAMIC_PANEL_TAB_INDEX_MAP.AUTOMATED_SEARCH
	const isOneTimeSearchPanel = index == DYNAMIC_PANEL_TAB_INDEX_MAP.ARTICLE_SEARCH

	const flexStyles = isAutomatedSearchPanel && (value === index) ? {
		display: "flex" ,
		justifyContent: "space-between",
		alignItems: "center",
	} : {}

	const flexHeightStyles = isOneTimeSearchPanel && (value === index) ? {
		maxHeight: "unset",
		minHeight: "40px",
		overflowY: "unset"
	} : {}

	return (
		<div
			role="tab-panel"
			style={{
				minWidth: "100%", 
				maxHeight: "40px",
				overflowY: "hidden",
				...flexStyles,
				...flexHeightStyles
			}}
			hidden={value !== index}
			id={`dynamic-tab-panel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
		>
			{children}
		</div>
	)
}
